module.exports = __webpack_public_path__ + "static/media/acis.87769742.jpg";